import firebase from 'firebase'

const config = {
  // apiKey: "AIzaSyCpSBm0ehBiEr4muaISG3Rgm_UNR6Bfd5M",
  // authDomain: "klatenkab-b26a2.firebaseapp.com",
  // projectId: "klatenkab-b26a2",
  // storageBucket: "klatenkab-b26a2.appspot.com",
  // messagingSenderId: "403502709904",
  // appId: "1:403502709904:web:b02f2ef8dee8cb1b0f2c15",
  // measurementId: "G-KB1K4C63J8"

  apiKey: "AIzaSyBqmMXHVkLehn2ORhr1CPmC9iheJB9OIfk",
  authDomain: "amanata-pos.firebaseapp.com",
  projectId: "amanata-pos",
  storageBucket: "amanata-pos.appspot.com",
  messagingSenderId: "853641210100",
  appId: "1:853641210100:web:19d5a9006c08942807d6a1"
}

if (!firebase.apps.length) {
  firebase.initializeApp(config)
}

const messaging = firebase.messaging()

messaging.usePublicVapidKey("BJtnDbk8eIbQpi8TlJEmI7RWYc3DhVTve67EF-qMeEUd56FrKqNHQ37x9wd53KUM0xV459edkr-sNbMq-W9z69Q")

export default firebase